import NotFound from "./NotFound";
import R from "resources/Namespace";

/**
 * @see Error.tsx for similar
 */
export default function PageNotFound() {
    return (
        <NotFound
            title={R.strings.errors.page_not_found.title}
            pageTitle={R.strings.errors.page_not_found.page_title}
        />
    );
}
